import React from "react";
import { Phone, Mail, User } from "lucide-react";

const TEAM = [
  {
    name: "KONÉ MAH SARA",
    role: "La Gérante",
    phones: ["0779148508", "0505352727"],
    email: "konemahsara@kmsserviceplus.com",
    initials: "KMS",
  },
  {
    name: "KINDIA BONI STANISLAS",
    role: "Agent Administratif · Assistant de la Gérante",
    phones: ["0758359132"],
    email: "kindiabonistanislas@kmsserviceplus.com",
    initials: "KBS",
  },
];

export default function Team() {
  return (
    <section id="team" data-testid="team-section" className="bg-white py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-2xl mb-14">
          <div className="kms-overline mb-4 flex items-center gap-4">
            <span className="font-heading font-black text-sm text-[#D90429]">06</span>
            <span className="h-px w-12 bg-[#D90429]" />
            <span>Direction</span>
          </div>
          <h2 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl tracking-tighter text-[#0A1128] leading-[1.05]">
            Une équipe <span className="text-[#D90429]">dédiée</span> à votre
            réussite.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {TEAM.map((m, i) => (
            <div
              key={m.name}
              data-testid={`team-card-${i}`}
              className="group relative bg-white border border-gray-200 text-[#0A1128] p-8 sm:p-10 overflow-hidden hover:shadow-2xl hover:border-[#0A1128] transition-all duration-500"
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#D90429] opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ clipPath: "polygon(100% 0, 0 0, 100% 100%)" }} />
              <div className="relative flex flex-col sm:flex-row gap-6 items-start">
                <div className="flex-shrink-0 w-20 h-20 sm:w-24 sm:h-24 border-2 border-[#0A1128] flex items-center justify-center font-heading font-black text-xl bg-[#0A1128] text-white">
                  {m.initials}
                </div>
                <div className="flex-1">
                  <div className="kms-overline" style={{ color: "#D90429" }}>
                    {m.role}
                  </div>
                  <h3 className="font-heading font-bold text-2xl sm:text-3xl mt-2 tracking-tight text-[#0A1128]">
                    {m.name}
                  </h3>
                  <div className="mt-6 space-y-2">
                    {m.phones.map((p) => (
                      <a
                        key={p}
                        href={`tel:+225${p}`}
                        data-testid={`team-${i}-phone-${p}`}
                        className="flex items-center gap-3 text-[#374151] hover:text-[#D90429] transition-colors"
                      >
                        <Phone size={16} />
                        <span className="font-semibold tracking-wide">
                          +225 {p.replace(/(\d{2})(\d{2})(\d{2})(\d{2})/, "$1 $2 $3 $4")}
                        </span>
                      </a>
                    ))}
                    {m.email && (
                      <a
                        href={`mailto:${m.email}`}
                        data-testid={`team-${i}-email`}
                        className="flex items-center gap-3 text-[#374151] hover:text-[#D90429] transition-colors pt-1"
                      >
                        <Mail size={16} />
                        <span className="font-semibold tracking-wide break-all">
                          {m.email}
                        </span>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
